import { render, staticRenderFns } from "./VFormRow.vue?vue&type=template&id=2e4d5439&"
import script from "./VFormRow.vue?vue&type=script&lang=js&"
export * from "./VFormRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports